import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { GodownService } from '../../_services/_masters/godown.service';
import { ConsignorService } from '../../_services/_masters/consignor.service';
import { SelectablesService } from '../../selectables.service';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Http, Response } from '@angular/http';
import { environment } from '../../../environments/environment';

import swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
// import * as $ from 'jquery';
declare var $ : any;
class godownMasterForm {
	station:string;
	consignor:string;
	godown_name:string;
	address : string;
	branch: string;
	contact_no: string;
}

@Component({
  selector: 'app-godown',
  templateUrl: './godown.component.html',
  styleUrls: ['./godown.component.css']
})
export class GodownComponent implements OnInit {
 	godownMasterForm : FormGroup;
	modalGodownMasterForm : FormGroup;
	modalData : any;

	// Data Table Configurations
	dtOptions: any = {};
	dataTable: any;
	dtTrigger: Subject<any> = new Subject();
	godown_form: godownMasterForm[] = [];

	stations : string[] = [];
	consignors: any[] = [];
	check_branch: boolean = true;
	selected_branch="";

	currentUser  : any ;
	token : any ;
	user_role : string = null ;
	user_branch : string = null ;
	url = environment.url;
	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;

	query : any = null;
	response : any = null;
	
	constructor( private godownService : GodownService,
		private selectBranchService : SelectablesService,
		private selectConsignorService : ConsignorService, 
		private http: Http
	) { }

	ngOnInit() {

		this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
		this.token = this.currentUser.token;
		this.user_role = this.currentUser.role;
		this.user_branch = this.currentUser.branch;
		console.log(this.user_role);
		console.log(this.user_branch);

		this.godownMasterForm = new FormGroup({
			'station': new FormControl(null , Validators.required),
			'consignor': new FormControl(null , Validators.required),
			'godown_name': new FormControl(null , Validators.required),
			'godown_prefix': new FormControl(null , Validators.required),
			'address': new FormControl(null , Validators.required),
			'phone_no': new FormControl(null , Validators.required)
		});
		
		this.modalGodownMasterForm = new FormGroup({
			'station': new FormControl(null , Validators.required),
			'consignor': new FormControl(null , Validators.required),
			'godown_name': new FormControl(null , Validators.required),
			'godown_prefix': new FormControl(null , Validators.required),
			'address': new FormControl(null , Validators.required),
			'phone_no': new FormControl(null , Validators.required)
		});


		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 5,
			responsive: true,
			// select:true,
			rowCallback: (row: Node, data: any[] | Object, index: number) => {
				const self = this;
				// Unbind first in order to avoid any duplicate handler
				// (see https://github.com/l-lin/angular-datatables/issues/87)
				$('td', row).unbind('click');
				$('td', row).bind('click', () => {
					self.someClickHandler(data);
				});
				return row;
			},
			dom: 'Bfrtip',
			// Configure the buttons
			buttons: [
				// 'columnsToggle',
				'colvis',
				'copy',
				'print',
				'excel'
			]
		};

	this.http.get(this.url + '/godown/all')
	// this.http.get('http://backendtransport.iogreen.in/masters/branchMaster/all')
		.map(this.extractData)
		.subscribe(forms => {
			this.godown_form = forms;
			console.log(this.godown_form);
			// Calling the DT trigger to manually render the table
			this.dtTrigger.next();
		});

		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);	
		if(localStorage.getItem('currentUser'))
		{
			if (temp["role"] === 'Admin')
			{
				this.getBranch();
				this.getConsignorBySelectedBranch(null);
				this.check_branch = false;
			}
			else if(temp['role'] === 'Manager' || temp['role'] === 'Employee')
			{
				this.godownMasterForm.get('station').setValue(temp['branch']);
				this.stations.push(temp['branch']);
				this.selected_branch=temp['branch'];
				this.getConsignorBySelectedBranch(temp['branch']);
				this.check_branch = true;
			}
		}
	}


	getBranch()
	{
		this.selectBranchService.getBranches()
		.subscribe(
			branches => {
				for(var i=0;i<branches.length;i++)
				{
					this.stations.push(branches[i]['branch_name']);
				}
			});
	}
	getConsignor()
	{
		this.selectConsignorService.getAllConsignor()
		.subscribe(
			consignors => {
				for(var i=0;i<consignors.length;i++)
				{
					this.consignors.push(consignors[i]['consignor_name']);
				}
			});
	}
	getConsignorBySelectedBranch(branch)
	{
		if(this.check_branch==false)
			this.selected_branch=branch;
		this.consignors=[];
		this.selectConsignorService.getConsignorFormWithBranch(branch)
		.subscribe(
			consignors => {
				//alert(consignors);
				
				for(var i=0;i<consignors.length;i++)
				{
					this.consignors.push(consignors[i]['consignor_name']);
				}
			});
	}
	getGodownBySelectedBranchAndClient(client)
	{
		this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				dtInstance.destroy();
				this.http.get(this.url + '/masters/godown/get/branchandclient/'+this.selected_branch+'/'+client)
					.map(this.extractData)
					.subscribe(forms => {
					this.godown_form = forms;
					console.log(this.godown_form);
					// Calling the DT trigger to manually render the table
					this.dtTrigger.next();
				});
			});
	}
	
	
	private extractData(res: Response) {
		const body = res.json();
		console.log(body.data || {});
		return body;

	};

	someClickHandler(info: any): void {
		this.godownService.getGodownMasterFormWith(info[0])
		.subscribe(response => {
			console.log('aaaaa'+JSON.stringify(response))
			this.modalData = JSON.stringify(response)
			this.modalData =JSON.parse(this.modalData)
			this.modalGodownMasterForm.patchValue({
				"station": this.modalData[0].station,
				"consignor": this.modalData[0].consignor,
				"godown_name": this.modalData[0].godown_name,
				"godown_prefix": this.modalData[0].godown_prefix,
				"address": this.modalData[0].address,
				"phone_no": this.modalData[0].phone_no
			});
		});	
		$("#default-modal").modal('show');
	};

	submit(){
		console.log(this.godownMasterForm.value);
		this.godownService.addNewGodown(this.godownMasterForm.value)
		.subscribe(response => 
		{			
			if(response['status'])
			{
				swal('Save', 'Record save successfully', 'success');
				this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
				{
					dtInstance.destroy();
					this.http.get(this.url + '/godown/all')
						.map(this.extractData)
						.subscribe(forms => 
						{
							this.godown_form = forms;
							console.log(this.godown_form);
							// Calling the DT trigger to manually render the table
							this.dtTrigger.next();
						});
				});
				
			}
			else
			{
				swal('Oops!', 'Something went wrong on the page! <br />'+ response['message'], 'error');
			}
		});
	};

	updateGodown(){
		console.log(this.modalGodownMasterForm.value);
		console.log(this.modalData);

		this.query={
			"godown_oid" : this.modalData[0]._id,
			"godown_data" : this.modalGodownMasterForm.value
		}

		console.log(this.query);

		this.http.post( this.url + "/godown/update", this.query)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			console.log(this.response.status);
			if (this.response.status){

				if (this.response.message === 'Godown Updated Successfully'){
					swal(
						'Success',
						'Godown Form Updated Successfully',
						'success'
					);
					this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
					{
						dtInstance.destroy();
						this.http.get(this.url + '/godown/all')
							.map(this.extractData)
							.subscribe(forms => 
							{
								this.godown_form = forms;
								console.log(this.godown_form);
								// Calling the DT trigger to manually render the table
								this.dtTrigger.next();
							});
					});

				}

				if (this.response.message === 'Godown Information not Changed'){
					swal(
						'Info',
						'Godown information not changed',
						'info'
					);
				}
			}
			else{
				swal(
					'Unknown Error',
					'Please Refresh your page',
					'error'
				);
			}
			
		});
	};


	// DELETE CONSIGNOR
	deleteGodown(){
		console.log("Hello");
		this.query={
			"godown_id" : this.modalData[0]._id.$oid,
			"station": this.modalData[0].station,
			"consignor": this.modalData[0].consignor
		}

		console.log(this.query);

		swal({
			title: 'Are you sure?',
			text: 'You want to delete Godown',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'No, keep it'
		}).then((result) => {
			if (result.value) {
				this.http.post(this.url + '/masters/godown/delete', this.query)
				.map(response => response.json())
				.subscribe(
					(response)=>{
						console.log(response);
						if (response["status"]){
							console.log(response);
							console.log("success");
							swal('Deleted!','Your Godown has been deleted.','success');

							this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
							{
								dtInstance.destroy();
								this.http.get(this.url + '/godown/all')
									.map(this.extractData)
									.subscribe(forms => 
									{
										this.godown_form = forms;
										console.log(this.godown_form);
										// Calling the DT trigger to manually render the table
										this.dtTrigger.next();
									});
							});
							
							$("#default-modal").modal("hide");
							
						}else{
							swal("error","Oops , Somthing went wrong, Godown is not deleted","error");
						}
					},
					(error)=>console.log(error.json())
					);
			} 
		})
	}

	// END

}




// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/masters/godown/godown.component.ts